import React from 'react';
import axios from 'axios';
import { withStyles } from '@material-ui/styles';
import {IconButton, InputBase, Typography } from '@material-ui/core';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';


const useStyles = (theme) => ({
  searchForm: {
    display: 'block', 
    position: 'relative', 
    width: 400,
    margin: '0 auto 8px auto',
    '@media (max-width:599px)': {
      width: '100%',
      minWidth: 270
    }
  },
  inputBase: {
    height: '38px',
    width: '100%',
    // visibility: 'hidden',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    paddingRight: '26px',
    '&:hover': {
      backgroundColor: 'rgba(12, 12, 12, 1)'
    },
    '& .MuiInputBase-input': {
      padding: '12px',
      height: '100%'
    },
  },
  searchIcon: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    position: 'absolute', 
    right: 0, 
    top: 0,
    height: '100%', 
    width: '38px', 
    borderRadius: '19px',
    cursor: 'pointer',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    '&:hover': {
      backgroundColor: 'rgba(12, 12, 12, 1)'
    }
  },
  container: {
    display: 'flex',
    width: '100%',
    minWidth: 270,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  card: {
    overflow: 'hidden',
    position: 'relative',
    height: 420,
    width: 270,
    minWidth: 270, 
    // flexGrow: 1,
    margin: 16,
    boxShadow: theme.shadows[7],
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },  
    '& .button': {
      position: 'absolute',
      right: 0,
      bottom: 0,
      zIndex: 3,
      padding: 16,
      color: 'rgb(200, 200, 200)'
      // borderRadius: 0,
      // marginTop: 8
    },
    '& .poster2': {
      position: 'relative', 
      overflow: 'hidden', 
      height: '100%', 
      width: '100%',
    },
    '& .details': {
      position: 'absolute',
      padding: 20,
      bottom: '-50px',
      // bottom: 0,
      left: 0,
      zIndex: 2,
      transition: 'all 0.5s ease',
      width: '100%',
      height: '44%',
      '& .tags': {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        marginBottom: 4,
        '& span': {
          padding: '2px 5px',
          borderRadius: 2,
          color: 'rgba(20, 20, 20, 0.975)',
          fontWeight: 500,
          marginRight: 4,
          backgroundColor: 'rgb(163, 102, 255)',
          boxShadow: theme.shadows[3],
        }
      },
      '& .tags2': {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        marginBottom: 24,
        '& span': {
          padding: '2px 5px',
          borderRadius: 2,
          color: 'rgba(20, 20, 20, 0.975)',
          fontWeight: 500,
          marginRight: 4,
          backgroundColor: 'rgb(204, 102, 204)',
          // backgroundColor: 'rgb(255, 153, 0)',
          boxShadow: theme.shadows[3],
        }
      },
    },
    '&:hover .details, &:hover .poster2:before': {
      bottom: 0,
    },
    '&:hover .img': {
      filter: 'blur(3px)',
    },
    '&:hover div.tags2': {
      marginBottom: 8,
    }
  },
  
});

// We can declare function rupiahFormat here (no need to bind with this)
class GamesComponent extends React.Component { // Using Class Component
	constructor(props) {
    super(props);
    this.state = {
      games: [],
      searchValue: '',
    }
    this.handleDetail = this.handleDetail.bind(this)
    this.truncateString = this.truncateString.bind(this)
    this.submitSearch= this.submitSearch.bind(this)
    this.searchChange = this.searchChange.bind(this)
  }

  componentDidMount() {
    axios.get(`https://backendexample.sanbersy.com/api/data-game`).then(res => {
      let result = res.data.map(el => {
        if (Boolean(el.name) === false) el.name = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.release) === false) el.release = " ";
        if (Boolean(el.platform) === false) el.platform = " ";
        if (Boolean(el.singlePlayer) === false) el.singlePlayer = 0;
        if (Boolean(el.multiplayer) === false) el.multiplayer = 0;
        let name = el.name.charAt(0).toUpperCase() + el.name.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let platform = el.platform.charAt(0).toUpperCase() + el.platform.slice(1)
        const { id, release, singlePlayer, multiplayer, image_url } = el;
        return { id, name, release, genre, platform, singlePlayer, multiplayer, image_url };
      })
      this.setState({games: result}); 
    });
  }

  submitSearch(e) {
    e.preventDefault();
    
    axios.get(`https://backendexample.sanbersy.com/api/data-game`).then(res => {
      let result = res.data.map(el => {
        if (Boolean(el.name) === false) el.name = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.release) === false) el.release = " ";
        if (Boolean(el.platform) === false) el.platform = " ";
        if (Boolean(el.singlePlayer) === false) el.singlePlayer = 0;
        if (Boolean(el.multiplayer) === false) el.multiplayer = 0;
        let name = el.name.charAt(0).toUpperCase() + el.name.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let platform = el.platform.charAt(0).toUpperCase() + el.platform.slice(1)
        const { id, release, singlePlayer, multiplayer, image_url } = el;
        return { id, name, release, genre, platform, singlePlayer, multiplayer, image_url };
      })
        
      let filteredName = result.filter(game => game.name.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredGenre = result.filter(game => game.genre.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredRelease = result.filter(game => game.release.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredPlatform = result.filter(game => game.platform.toLowerCase().indexOf(this.state.searchValue.toLowerCase()) !== -1);
      let filteredSingle = result.filter(game => {
        if ("singlePlayer".toLowerCase().includes(this.state.searchValue.toLowerCase())) return game.singlePlayer === 1;
      })
      let filteredMulti = result.filter(game => {
        if ("multiplayer".toLowerCase().includes(this.state.searchValue.toLowerCase())) return game.multiplayer === 1;
      })
      let newGames = [...filteredName, ...filteredGenre, ...filteredRelease, ...filteredPlatform, ...filteredSingle, ...filteredMulti];
      this.setState({games: [...new Set(newGames)], input: '' });
    })
  }

  searchChange(e) {
    this.setState({searchValue: e.target.value});
  }

  truncateString(str, num) {
    if (str === null) return '';
    if (str.length <= num) return str;
    return str.slice(0, num) + '...';
  }

  handleDetail(event) {
    let detailId = event.currentTarget.value;
    this.props.history.push(`/game/detail/${detailId}`)
  }

  render() {
    const { classes } = this.props;
    return(
      <>
        <form onSubmit={this.submitSearch} className={classes.searchForm}>
          <InputBase 
            type="text" 
            title="search by name, genre, release, platform and mode" 
            placeholder="Type anything..." 
            title="Search"
            value={this.state.searchValue} 
            onChange={this.searchChange} 
            className={classes.inputBase} 
          />
          <IconButton 
            onClick={this.submitSearch}
            disableFocusRipple
            disableRipple
            className={classes.searchIcon}  
          >
            <SearchRoundedIcon />
          </IconButton>
        </form>
        <div className={classes.container}>
          {
            this.state.games.map((item) => {
              return(
                <div key={item.name} className={classes.card}>
                  <IconButton className="button" onClick={this.handleDetail} value={item.id}>
                    <OpenInNewRoundedIcon fontSize="small" /> 
                  </IconButton>
                  <div className="poster2">
                    <div 
                      className='img' 
                      style={{
                        height: '100%', 
                        transition: 'all 0.5s ease', 
                        background: `url(${item.image_url}) center/auto 100% no-repeat rgba(10, 10, 10, 0.975)`, 
                        border: '2px solid rgba(12, 12, 12, 0.975)',
                        // border: '2px solid rgba(26, 26, 26, 0.975)',
                        // border: '1px solid rgb(163, 102, 255)'
                    }} />
                  </div>  
                  <div className="details">
                    <Typography variant="h2" style={{textTransform: 'capitalize', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 22, verticalAlign: 'middle', fontWeight: 500}}>{item.name}</Typography>
                    <span style={{color: 'rgb(144, 144, 144)', fontSize: 14, lineHeight: 'normal'}}>{item.release}</span> 
                    <div className="tags">
                      {item.genre.includes(',') 
                        ? <span>{this.truncateString(item.genre.split(',')[0].trim().charAt(0).toUpperCase() + item.genre.split(',')[0].trim().slice(1), 14)}</span> 
                        : <span>{this.truncateString(item.genre.trim().charAt(0).toUpperCase() + item.genre.trim().slice(1), 25)}</span>
                      } 
                      {item.genre.split(',')[1]
                        ? <span>{this.truncateString(item.genre.split(',')[1].trim().charAt(0).toUpperCase() + item.genre.split(',')[1].trim().slice(1), 14)}</span> 
                        : <></>
                      } 
                    </div>
                    <div className="tags2">
                      {item.singlePlayer !== 0 && 
                        <span>Single Player</span> 
                      }
                      {item.multiplayer !== 0 && 
                        <span>Multi Player</span> 
                      }
                    </div>
                    <div> 
                      <span style={{color: 'rgb(144, 144, 144)'}}>Available on : </span> {this.truncateString(item.platform, 40)}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </>
    )
  }
}

export default withStyles(useStyles)(GamesComponent);
 